import { render } from "./FormDesignRender.html?vue&type=template&id=67b0c8e4&scoped=true&ts=true"
import script from "./FormDesignRender.ts?vue&type=script&lang=ts"
export * from "./FormDesignRender.ts?vue&type=script&lang=ts"

import "./FormDesignRender.scss?vue&type=style&index=0&id=67b0c8e4&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b0c8e4"]])

export default __exports__